import { render, staticRenderFns } from "./TableRatePlanHeader.vue?vue&type=template&id=641a5288&scoped=true&"
import script from "./TableRatePlanHeader.vue?vue&type=script&lang=js&"
export * from "./TableRatePlanHeader.vue?vue&type=script&lang=js&"
import style0 from "./TableRatePlanHeader.vue?vue&type=style&index=0&id=641a5288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641a5288",
  null
  
)

export default component.exports